// buy-now.js
function syncBuyNowButton(addBtn, buyBtn) {
  if (buyBtn.dataset.loading === 'true') return; // don't fight the click handler mid-request

  const soldOut = addBtn.disabled;
  const addLabel = (addBtn.querySelector('span') || addBtn).textContent.trim();

  if (buyBtn.disabled !== soldOut) {
    buyBtn.disabled = soldOut;
  }

  const newLabel = soldOut ? addLabel : 'Buy Now';
  if (buyBtn.textContent !== newLabel) {
    buyBtn.textContent = newLabel;
  }
}

function watchProductForm(form) {
  const addBtn = form.querySelector('[name="add"]');
  const buyBtn = form.querySelector('.buy-now-button');
  if (!addBtn || !buyBtn) return;

  syncBuyNowButton(addBtn, buyBtn);

  // Scoped to addBtn only — buyBtn is a sibling, so writes to buyBtn
  // below never trigger this observer. That's what prevents the loop.
  const observer = new MutationObserver(function () {
    syncBuyNowButton(addBtn, buyBtn);
  });
  observer.observe(addBtn, {
    attributes: true,
    attributeFilter: ['disabled'],
    childList: true,
    subtree: true,
    characterData: true
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('product-form').forEach(watchProductForm);

  document.body.addEventListener('click', function (e) {
    const btn = e.target.closest('.buy-now-button');
    if (!btn || btn.disabled) return;

    e.preventDefault();

    const form = btn.closest('form');
    if (!form) return;

    const formData = new FormData(form);
    const originalText = btn.textContent;
    btn.dataset.loading = 'true';
    btn.disabled = true;
    btn.textContent = 'Loading…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Add to cart failed with status ' + res.status);
        }
        window.location.href = '/checkout';
      })
      .catch((err) => {
        console.error(err);
        delete btn.dataset.loading;
        btn.disabled = false;
        btn.textContent = originalText;
        alert('Something went wrong — please try again.');
      });
  });
});